/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../spinner/spinner.ngfactory';
import * as import2 from 'ionic-angular/components/spinner/spinner';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from 'ionic-angular/components/loading/loading-component';
import * as import5 from 'ionic-angular/components/backdrop/backdrop';
import * as import6 from '@angular/common';
import * as import7 from 'ionic-angular/navigation/view-controller';
import * as import8 from 'ionic-angular/gestures/gesture-controller';
import * as import9 from 'ionic-angular/navigation/nav-params';
const styles_LoadingCmp:any[] = ([] as any[]);
export const RenderType_LoadingCmp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LoadingCmp,
  data: {}
}
);
function View_LoadingCmp_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'loading-spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-spinner',([] as any[]),[[
        2,
        'spinner-paused',
        (null as any)
      ]
    ],(null as any),(null as any),import1.View_Spinner_0,import1.RenderType_Spinner)),
    import0.ɵdid(114688,(null as any),0,import2.Spinner,[
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.d.spinner;
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,2)._paused;
    ck(v,1,0,currVal_0);
  });
}
function View_LoadingCmp_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'loading-content'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.d.content;
    ck(v,0,0,currVal_0);
  });
}
export function View_LoadingCmp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-backdrop',[
      [
        'disable-activated',
        ''
      ]
      ,
      [
        'role',
        'presentation'
      ]
      ,
      [
        'tappable',
        ''
      ]

    ]
    ,[
      [
        8,
        'hidden',
        0
      ]
      ,
      [
        2,
        'backdrop-no-tappable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.LoadingCmp = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.bdClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import5.Backdrop,[
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'loading-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoadingCmp_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoadingCmp_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import4.LoadingCmp = v.component;
    const currVal_2:any = co.showSpinner;
    ck(v,4,0,currVal_2);
    const currVal_3:any = co.d.content;
    ck(v,6,0,currVal_3);
  },(ck,v) => {
    var co:import4.LoadingCmp = v.component;
    const currVal_0:boolean = !co.d.showBackdrop;
    const currVal_1:boolean = !co.d.enableBackdropDismiss;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_LoadingCmp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-loading',[[
        'role',
        'dialog'
      ]
      ],(null as any),[[
        'body',
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('body:keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).keyUp($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_LoadingCmp_0,RenderType_LoadingCmp)),
    import0.ɵdid(245760,(null as any),0,import4.LoadingCmp,[
      import7.ViewController,
      import3.Config,
      import0.ElementRef,
      import8.GestureController,
      import9.NavParams,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const LoadingCmpNgFactory:import0.ComponentFactory<import4.LoadingCmp> = import0.ɵccf('ion-loading',import4.LoadingCmp,View_LoadingCmp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/loading/loading-component.ngfactory.ts